// extracted by mini-css-extract-plugin
module.exports = {"content":"AdmissionRequirements_content__2MZ8F","text":"AdmissionRequirements_text__sGScU"};